'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Sorting = exports.Sorting = undefined;

exports.Sorting = Sorting = function Sorting(refs, config) {
    var t = this;

    t.id = config.id || null;
    t.direction = config.direction || null;
    t.emptyFirst = config.emptyFirst || false;

    var _keyMap = {
        'asc': 'DESC',
        'desc': 'ASC'
    };

    t.getKeyMap = function () {
        return _keyMap;
    };
};

Sorting.prototype.toggleDirection = function () {
    this.direction = this.getKeyMap()[(this.direction || '').toLowerCase()];
};
//# sourceMappingURL=Sorting.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Sorting.js
 ** module id = 123
 ** module chunks = 0 1
 **/